/* eslint-disable */
export default class HeaderSearch {
  constructor() {
    this.header = document.querySelector('.js-search-button');
    if (this.header === null) return;
    this.searchButton = document.querySelector('.js-search-button');
    this.closeSearchButton = document.querySelector('.js-close-button');
    this.searchButton.addEventListener('click', () => {
      this.openSearchField();
    });
    this.closeSearchButton.addEventListener('click', () => {
      this.closeSearchField();
    });
  }

  openSearchField() {
    document.querySelector('header').classList.contains('-search-open') ? document.querySelector('header').classList.remove('-search-open') : document.querySelector('header').classList.add('-search-open');
  }

  closeSearchField() {
    document.querySelector('header').classList.remove('-search-open');
  }
}
